export default __webpack_public_path__ + "static/media/bumper_0.9639e339.jpg";